export default {
  props: ['section'],
  data:
		function () {
			return {
			}
	},
  created: function () {
  },
  methods: {
			trigger: function(){
        this.$emit('trigger');
			}
  }
}
